import {
  AccountManagementApi,
  CustodianControllerApi,
} from "@iliotech/generated-api-v3";
import { useQuery } from "react-query";
import { API_BASE } from "../../../constants/constants";
import { useLandingCurrencyContext } from "../../context";

export const usePortfoliosSummary = (externalAccountId: string) => {
  const api = new AccountManagementApi(undefined, `${API_BASE}/api`);
  const { currency } = useLandingCurrencyContext();
  return useQuery([`portfolios-summary`, { externalAccountId, currency }], () =>
    api.getCurrentUserPortfoliosSummary(externalAccountId, currency)
  );
};
